import { Steps as AntSteps } from 'antd';
import styled from 'styled-components';

export const Steps = styled(AntSteps)`
  & .ant-steps-item-container {
    display: flex;
    flex-direction: column-reverse;
  }
  & .ant-steps-item-tail {
    position: relative !important;
    &::after {
      background: var(--neutral_medium) !important;
    }
  }

  & .ant-steps-icon-dot,
  & .ant-steps-item-icon {
    width: 14px !important;
    height: 14px !important;
    background: #fff !important;
    border: 2px solid var(--neutral_medium);
  }
  & .ant-steps-icon {
    top: 0px !important;
  }

  & .ant-steps-item-active {
    & .ant-steps-icon-dot {
      background: var(--green-sea_medium) !important;
      border: 2px solid var(--green-sea_dark);
    }
    & .status-title,
    & .status-subtitle {
      color: var(--neutral_medium) !important;
    }
  }

  & .ant-steps-item-tail {
    top: -9px !important;
    margin: 0 0 0 72px !important;
  }

  & .status-title-container {
    margin-bottom: 10px;
    & .status-title,
    & .status-subtitle {
      display: block;
      color: var(--neutral_light);
    }
    & .status-title {
      font-weight: 500;
    }
  }
`;

export const SubStatusWrapper = styled.div`
  background: #fff;
  & .sub-status-title {
    text-align: center;
    padding-bottom: 15px;
    & .title {
      font-weight: 600;
      font-size: 16px;
    }
    & .id {
      color: #a0bace;
      display: inline-block;
      margin-left: 8px;
    }
  }
`;

export const StaymentLogWrapper = styled.div`
  /* Container principal com margem inferior extra para o scrollbar */
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-top: 40px;
  padding-bottom: 100px; /* Espaço adicional para o scrollbar - aumentado significativamente */
  background: #fff;
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  /* Adiciona uma div interna com padding para afastar o conteúdo do scrollbar */
  & > .ant-steps {
    margin-bottom: 80px; /* Aumentado significativamente o espaço entre o conteúdo e o scrollbar */
    padding-bottom: 30px; /* Adiciona padding extra na parte inferior */
  }
  /* Padding de conteúdo para garantir espaço para scrollbar */
  &::after {
    content: '';
    height: 80px;
    width: 100%;
    position: absolute;
    bottom: 30px; /* Posicionado mais abaixo do conteúdo principal */
    left: 0;
    background: transparent;
    pointer-events: none; /* Garante que o elemento não interfira nos cliques */
    z-index: 1; /* Garantindo que fique acima do scrollbar */
  }
  /* Custom scrollbar styling */
  /* Estilo do scrollbar para Firefox */
  scrollbar-width: thin;
  scrollbar-color: #c0c0c0 #f1f1f1;
  /* Estilo do scrollbar para Chrome, Safari e Edge */
  &::-webkit-scrollbar {
    height: 8px;
    margin-top: 60px;
    position: absolute;
    bottom: 5px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #c0c0c0;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a0a0a0;
  }
`;
